import React, { ReactElement, FC } from "react";
import { graphql, PageProps } from "gatsby";
import { PartialShowcase, PartialMarket, PartialBrand } from "../types/types";
import { Layout } from "../components/Layout/Layout";
import { Hero } from "../components/Hero/Hero";
// import { FullQuote } from "../components/FullQuote/FullQuote";
// import { FeatureGrid } from "../components/FeatureGrid/FeatureGrid";
import { CardCarousel } from "../components/CardCarousel/CardCarousel";
import { ShowcaseCard } from "../components/Cards/ShowcaseCard";
import { SEO } from "../components/SEO/SEO";
import { Editor } from "../components/Editor/Editor";
import { Callout } from "../components/Callout/Callout";
// import { Award } from "../components/Award/Award";
import { Demo } from "../components/Demo/Demo";
import { BrandsCarousel } from "../components/Brands/BrandsCarousel";
import { Brand } from "../components/Brands/Brand";
// import { WhoForCards } from "../components/WhoForCards/WhoForCards";

type HomePageProps = PageProps<{
	showcases: {
		nodes: PartialShowcase[];
	};
	markets: {
		nodes: PartialMarket[];
	};
	brands: {
		nodes: PartialBrand[];
	};
}>;

const IndexPage: FC<HomePageProps> = ({
	data: {
		showcases: { nodes: showcases },
		brands: { nodes: brands },
	},
}): ReactElement => {
	return (
		<Layout>
			<SEO />

			<Hero />

			<Demo />

			<BrandsCarousel>
				{brands.map((brand) => {
					return <Brand key={brand.id} content={brand} />;
				})}
			</BrandsCarousel>

			<Editor />

			{/* <WhoForCards /> */}

			{/* <FeatureGrid />

			<FullQuote citeName="Tanis M" citeCompany="Quadmark">
				“ We’ve seen a 400% behaviour uplift on completion of our
				training!&nbsp;”
			</FullQuote>

			<Award /> */}

			{/* <CardCarousel
				heading="Games Built with Adeptly"
				cta="Explore more games"
				ctaLink="/showcase/"
			>
				{markets.map((item) => {
					return <MarketCard key={item.id} content={item} />;
				})}
			</CardCarousel> */}

			<CardCarousel
				heading="Games and templates built with Adeptly"
				cta="Explore more games"
				ctaLink="/showcase/"
			>
				{showcases.map((item) => {
					return <ShowcaseCard key={item.id} content={item} />;
				})}
			</CardCarousel>

			<Callout />
		</Layout>
	);
};

export default IndexPage;
export const pageQuery = graphql`
	{
		showcases: allPrismicShowcase(
			limit: 10
			sort: {
				fields: [data___is_featured, first_publication_date]
				order: [ASC, DESC]
			}
		) {
			nodes {
				...PartialShowcase
			}
		}
		brands: allPrismicBrand {
			nodes {
				id
				data {
					image {
						url
						alt
					}
				}
			}
		}
		markets: allPrismicMarket(limit: 10) {
			nodes {
				id
				tags
				data {
					title {
						text
					}
					summary {
						richText
					}
					image {
						alt
						url
						fluid: gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
					}
					link {
						url
					}
				}
			}
		}
	}
`;
